import axios from "axios";
import baseUrl from "..";
import { authToken, authUserID, axiosInstance } from "../axiosConfig";

  const listDeviceList = async (page : any, pageSize: any, sort : any , order:any , keyword?:any) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/device/list_all?page=${page}&size=${pageSize}&sort=${sort}&order=${order}&status=active,inactive&keyword=${keyword}&type_ids=&id`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
}


const registerDevice = async (dataToSend: any) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/device/create`, dataToSend,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}


const changeDeviceStatus = async (id: string, status: string, x_auth_token: string, x_user_id: string , interface_name : string) => {
  try {
      const headers = {
        'x-auth-token': x_auth_token,
        'x-userid': x_user_id,
      };
      const response = await axiosInstance.post(`${baseUrl}/device/change_status`, {
          id: id,
          status: status,
          interface_name: interface_name
      }, { headers });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
  }
}

const listLogDetails = async () => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/system_logs/list`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const listSop = async (page : any, pageSize: any, sort : any , order:any) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/sop/list_sops?page=${page}&size=${pageSize}&sort=${sort}&order=${order}`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const SopFIleUpload = async (dataToSend:any) => {
  try {
    const formData = new FormData();
    formData.append('file', dataToSend); // 'file' should match the name expected by the API

    const response = await axiosInstance.post(`${baseUrl}/files/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'x-auth-token': authToken,
        'x-userid': authUserID
      }})
  
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const startSopSubmit = async (dataToSend : any) => {
  try {
    const headers = {
      'x-auth-token': authToken,
      'x-userid': authUserID,
    };
    const response = await axiosInstance.post(`${baseUrl}/sop/save_sops`, dataToSend , { headers });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const listHolidays = async (page : any, pageSize: any , year: any,  keyword: string,sort : any , order:any) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/holiday/list_yearly_holiday?page=${page}&size=${pageSize}&sort=${sort}&order=${order}&status=active,inactive&year=${year}&keyword=${keyword}`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const listWeekends = async (page : any, pageSize: any, keyword: string, sort : any , order:any) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/holiday/list_weekends?page=${page}&size=${pageSize}&sort=${sort}&order=${order}&id=&keyword=${keyword}&status=active,inactive`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}


const listHolidayName = async (page : any, pageSize: any , keyword: any, sort : any , order:any) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/holiday/list?page=${page}&size=${pageSize}&sort=${sort}&order=${order}&keyword=${keyword}&status=active,inactive`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const getMasterDropDown = async () => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/holiday/list?sort=id&order=desc&status=active`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};


const SubmitHoliday = async (dataToSend: any) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/holiday/add_yearly_holiday`, dataToSend,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const AddHoliday = async (dataToSend: any) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/holiday/add_holiday`, dataToSend,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const AddWeekHoliday = async (dataToSend: any) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/holiday/save_weekend`, dataToSend,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}


const changeHolidayStatus = async (policy_id: string, status: string , interface_name : string) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/holiday/change_holiday_status`, {
      id: policy_id,
      status: status,
      interface_name: interface_name
    },{
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const changeWeekHolidayStatus = async (policy_id: string, status: string, interface_name : string) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/holiday/change_weekend_status`, {
      id: policy_id,
      status: status,
      interface_name: interface_name
    },{
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const changeYearlyHolidayStatus = async (policy_id: string, status: string , interface_name : string) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/holiday/change_yearly_holiday_status`, {
      id: policy_id,
      status: status,
      interface_name: interface_name
    },{
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const listNotification = async (page : any, pageSize: any, keyword: any, sort : any , order:any) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/notification/list_notification_settings?page=${page}&size=${pageSize}&sort=${sort}&order=${order}&keyword=${keyword}`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const changeNotificationStatus = async (id: string, status: string, x_auth_token: string, x_user_id: string , interface_name : string) => {
  try {
      const headers = {
        'x-auth-token': x_auth_token,
        'x-userid': x_user_id,
      };
      const response = await axiosInstance.post(`${baseUrl}/notification/change_notification_status`, {
          id: id,
          status: status,
          interface_name: interface_name
      }, { headers });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
  }
}


const listdownloadReport = async (page : any, pageSize: any, sort: any , order:any , keyword: any,fileStatus:any,generatedby?:any,
  fromDate?: string,
  toDate?: string,) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/docs/list?page=${page}&size=${pageSize}&sort=${sort}&order=${order}&downloads_type_id=${keyword}&file_status=${fileStatus}&user_id=${generatedby}&start_date_time=${fromDate}&end_date_time=${toDate}&scope=`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const listReportType = async () => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/docs/list_types?status=active`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}
const publishButton = async (id:any) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/docs/publish?id=${id}`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}
const checkPublishedOrNot = async (id:any) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/docs/check_published?id=${id}`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}



const ApproveButton = async (dataToSend: any) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/docs/approve`,
      dataToSend,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

  const deviceRegistration = {
    listDeviceList,
    registerDevice,
    changeDeviceStatus,
    listLogDetails,
    listSop,
    SopFIleUpload,
    startSopSubmit,
    listHolidays,
    listWeekends,
    getMasterDropDown,
    SubmitHoliday,
    AddHoliday,
    AddWeekHoliday,
    changeHolidayStatus,
    changeYearlyHolidayStatus,
    changeWeekHolidayStatus,
    listHolidayName,
    listNotification,
    changeNotificationStatus,
    listdownloadReport,
    listReportType,
    ApproveButton,
    publishButton,
    checkPublishedOrNot
  };
  
  
export { deviceRegistration };